import { Injectable } from '@angular/core';
import { MenuType } from '../enums/menuType';
import {Location} from '@angular/common';
import { OrganizationLicenseModuleType } from '../enums/organizationLicenseModuleType';
import { OrganizationLicenseModule } from '../models/organizationLicenseModule';

@Injectable({
    providedIn: 'root',
  })
export class ModuleHelper {

    constructor(
      private readonly location: Location
      ) {}

    public getMenuType() {
      if (this.location.path().includes("manager")) {
        return MenuType.Manager;
      } else if (this.location.path().includes("grower")) {
        return MenuType.Grower;
      } else if (this.location.path().includes("organizations-settings")) {
        return MenuType.OrganizationSettings;
      } else if (this.location.path().includes("platform-administration")) {
        return MenuType.PlatformAdministration;
      } else {
        return MenuType.Generic;
      }
    }

    public getModuleType() {
      if (this.location.path().includes("manager")) {
        return OrganizationLicenseModuleType.Manager;
      } else if (this.location.path().includes("grower")) {
        return OrganizationLicenseModuleType.Grower;
      } else {
        return OrganizationLicenseModuleType.Manager;
      }
    }

    public getModuleRoute() {
      if (this.location.path().includes("manager")) {
        return 'manager';
      } else if (this.location.path().includes("grower")) {
        return 'grower';
      } else {
        return 'manager';
      }
    }

    public getModuleName(menuType: MenuType) {
      if (menuType === MenuType.Manager) {
        return 'manager';
      } else if (menuType === MenuType.Grower) {
        return 'grower';
      } else {
        return 'manager';
      }
    }

    public getModuleNameFromLicense(license: OrganizationLicenseModule) {
     return this.getModuleNameFromLicenseModuleType(license.organizationModule );
    }

    public getModuleNameFromLicenseModuleType(licenseModuleType: OrganizationLicenseModuleType) {
      if (licenseModuleType === OrganizationLicenseModuleType.Manager) {
        return 'manager';
      } else if (licenseModuleType === OrganizationLicenseModuleType.Grower) {
        return 'grower';
      } else {
        return 'manager';
      }
    }

    public getModulePrefixFromUrl(url: string): string{
      return url.indexOf('manager')>-1?'manager':'grower';
    }

    getModuleNameFromLocation(){
      const moduleType = this.getModuleType();
      return this.getModuleNameFromLicenseModuleType(moduleType);
    }
}
